import Vue from 'vue';
import { Geschlecht } from '@/types/Geschlecht';
import PatPatient from '@/types/Patient';

export type Card = string;

export class CardInfo {
    /** Geburtsdatum (z.B. 1980-01-01) */
    public birthDate!: string;
    /** Kartentyp (z.B. e-card) */
    public cardType!: string;
    /** Nachname (z.B. Musterpatient) */
    public familyName!: string;
    /** Vorname (z.B. Max) */
    public givenName!: string;
    /** Sozialversicherungsnummer (z.B. 1001210995) */
    public number!: string;
    /** Titel (z.B. Mag.) */
    public prefix!: string;
    /** Geschlecht (z.B. m) */
    public sex!: string;
    /** Titel nach dem Namen (z.B. MSc) */
    public suffix!: string;

    constructor(data?: Partial<CardInfo>) {
        Object.assign(this, data);
    }

    public get nachname(): string {
        return this.familyName ?? '';
    }

    public get vorname(): string {
        return this.givenName ?? '';
    }

    public get nachnameVorname(): string {
        const { nachname, vorname } = this;
        return nachname + (vorname !== '' ? ` ${vorname}` : '');
    }

    public get geburtsdatum(): string {
        return Vue.prototype.$d(this.birthDate);
    }

    public get svnr(): string {
        return this.number ?? '';
    }

    public get geschlecht(): string | null {
        switch (this.sex) {
            case 'm':
                return Geschlecht.Maennlich;
            case 'f':
                return Geschlecht.Weiblich;
            default:
                return null;
        }
    }

    public hasSameNachnameAs(patient: PatPatient): boolean {
        return patient.nachname?.toLocaleUpperCase()?.trim() ===
            this.familyName?.toLocaleUpperCase()?.trim();
    }

    public hasSameVornameAs(patient: PatPatient): boolean {
        const vorname = patient.vorname?.toLocaleUpperCase()?.trim();
        return vorname === this.givenName?.toLocaleUpperCase();
    }

    public hasSameGeburtsdatumAs(patient: PatPatient): boolean {
        return patient.geburtsdatum === this.birthDate;
    }

    public hasSameSvnrAs(patient: PatPatient): boolean {
        return patient.svnr === this.number;
    }
}
